// this file added by Bearer Web Developer
import React from "react";
import styles from './situation.module.scss';
import { observer } from "mobx-react-lite";
import { IOrderState, TransportStateEnum } from "../../../states/app-state";
interface Props {
    order: IOrderState
}
const Situation: React.FC<Props> = observer(({ order }) => {

    const step: TransportStateEnum | null = order?.transport?.step;
    const completed = step === TransportStateEnum.RiderCompletedTransport;
    const text = step === TransportStateEnum.RiderOnTheWayToOrigin ? "Accepted" : step === TransportStateEnum.RiderArrivesToOrigin ? "Arrived to Org" :
        step === TransportStateEnum.RiderPickupParcel ? "Picked Up" : step === TransportStateEnum.RiderArrivesToDestination ? "Arrived to Dest" :
            step === TransportStateEnum.RiderGetsPermissionToDropOff ? "Dropped Off" : completed ? "Completed" : step === TransportStateEnum.RiderCancelledTransport ? "New Search?" : "";

    return (
        <>
            {text &&
                <div className={`${styles.situation} ${completed ? styles.completed : order?.isSelected ? styles.selected : ''}`}>
                    <span></span>
                    <p>{text}</p>
                </div>
            }
        </>
    )
});
export default Situation;